module.exports = __webpack_public_path__ + "static/media/bird.feb2f8ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/bird.svg
// module id = 481
// module chunks = 0